import React from 'react'

import CoverSelectorGallery from "./galery/gallery"
import CoverSelectorLink from "./link/link"
import AttachmentsCollection from "../../../../model2/attachment/attachments"
import CoverSelectorAttachments from "./attachments/attachments"
import {Cover} from "../../../../model2/task/properties/cover"
import {CoverType} from "../../cover-type";

type Props = {
    currentCoverType    : CoverType

    cover?              : Cover
    attachments?        : AttachmentsCollection

    onCoverSelected     : {(cover:Cover):void}
}

const debug = false
// const debug = "CoverSelectorMain"

export default function CoverSelectorMain (props:Props) {

    switch (props.currentCoverType) {
        case CoverType.GALLERY      :
            return <CoverSelectorGallery onCoverSelected = {props.onCoverSelected}/>

        case CoverType.LINK      :
            return <CoverSelectorLink cover             = {props.cover}
                                      onCoverSelected   = {props.onCoverSelected}/>

        case CoverType.ATTACHMENT  :
            return <CoverSelectorAttachments attachments        = {props.attachments}
                                             onCoverSelected    = {props.onCoverSelected}/>
    }

    return null
}
